export default "__VITE_ASSET__n2RgbIEp__"